import Ajv from 'ajv';
import resultTestSchema from '../schemas/result_test.schema.json';
import questionsSchema from '../schemas/questions.schema.json';
import demographicsSchema from '../schemas/demographics.schema.json';

export function deepClean<T>(obj: T): T {
  if (obj === null || typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) return obj.map(deepClean) as unknown as T;
  const cleaned: Record<string, unknown> = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = (obj as Record<string, unknown>)[key];
      if (value !== undefined) cleaned[key] = deepClean(value);
    }
  }
  return cleaned as T;
}

export function validateData(schemaName: string, data: unknown): void {
  let schema;
  switch (schemaName) {
    case 'result_test.schema.json':
      schema = resultTestSchema;
      break;
    case 'questions.schema.json':
      schema = questionsSchema;
      break;
    case 'demographics.schema.json':
      schema = demographicsSchema;
      break;
    default:
      throw new Error('Unknown schema: ' + schemaName);
  }
  const ajv = new Ajv({ allErrors: true, strict: false });
  const validate = ajv.compile(schema);
  if (!validate(data)) {
    throw new Error('Validation error: ' + JSON.stringify(validate.errors));
  }
} 